/* eslint-disable no-param-reassign */
import { createAction, createReducer } from '@reduxjs/toolkit';
import hondaRestApi from '../apis/hondaRestApi';
import { GET_BUILD_ERROR_CODE } from '../apiHooks/types';
export const userInteractedWithBap = createAction('savedBuild/userInteractedBap');
export const displayedSummaryAlerts = createAction('savedBuild/displaySummaryAlert');
export const initialState = {
    currentBuilds: {},
    visibleAlerts: { config: false, price: false },
    userInteractions: { config: false, warranty: false, paymentCalculator: false },
};
const savedBuild = createReducer(initialState, builder => {
    builder
        .addCase(displayedSummaryAlerts, (state, action) => {
        state.visibleAlerts = { ...state.visibleAlerts, ...action.payload };
    })
        .addCase(userInteractedWithBap, (state, action) => {
        state.userInteractions = { ...state.userInteractions, ...action.payload };
    })
        .addMatcher(hondaRestApi.endpoints.getSavedBuild.matchFulfilled, (state, action) => {
        var _a;
        const { payload, meta } = action;
        if (!(payload === null || payload === void 0 ? void 0 : payload.isSuccess) && (payload === null || payload === void 0 ? void 0 : payload.errorCode) === GET_BUILD_ERROR_CODE) {
            state.currentBuilds[meta.arg.originalArgs.buildId] = { isError: true, scopes: [] };
            return;
        }
        if (!((_a = payload === null || payload === void 0 ? void 0 : payload.model) === null || _a === void 0 ? void 0 : _a.isAvailableInBap)) {
            state.currentBuilds[meta.arg.originalArgs.buildId] = { isError: true, scopes: [] };
            return;
        }
        state.currentBuilds[meta.arg.originalArgs.buildId] = payload;
    });
});
export const selectVisibleAlerts = (state) => state.savedBuild.visibleAlerts;
export const selectUserBapInteractions = (state) => state.savedBuild.userInteractions;
export const selectBuildById = (state, id) => (id && state.savedBuild.currentBuilds[id]) || null;
export default savedBuild;
